import React ,{useState,useEffect} from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import TitleHeader from 'components/presenters/header/TitleHeader';
import MyjoinGrouplist from 'components/grouppage/groupdtail/MyjoinGrouplist';
import MyjoinCampaignlist from 'components/grouppage/groupdtail/MyjoinCampaignlist';
import serverController from 'server/serverController';


export default function MyPageProjectsListLayout() {
    const userInfo = useSelector(state=>{ return state.userInfo}); 
    // 그룹상세
    const [campaignlist , setCampaignlist] = useState([]);
    const [groupslist , setGroupslist] = useState([]);
    const infoCallBack=(jsonData)=>{
        if(jsonData.success !== 1){
            alert("예기치 못한 문제가 발생하였습니다.");
            return;
        }
       
        setCampaignlist(jsonData.data.campaigns);
    }
    //근데 이 페이지에다가 하시는 이유가 있어용? 없어요 지금 데이터 받는 페이지 여기 아니에욥? 
    const groupsinfoCallBack=(jsonData)=>{
        if(jsonData.success !== 1){
            alert("예기치 못한 문제가 발생하였습니다.");
            return;
        }
        setGroupslist(jsonData.data.projects);
    }
    //페이지가 렌더링이 되었을 때 한번 호출
    useEffect(() => {
        serverController.getServerData(`users/${userInfo['id']}/campaigns`,infoCallBack);
        serverController.getServerData(`users/${userInfo['id']}/projects`,groupsinfoCallBack);
    },[]);
    return(

        <MypageCampaignInner>
            <TitleHeader title={"참여 챌린지"} borderbottom={"solid calc(100vw*(1/375)) #d5d5d5"}/>
            <MyjoinCampaignlist
                title={"챌린지"} 
                display={"none"} 
                item={campaignlist}
                campaignlist={campaignlist}
            /> 
        </MypageCampaignInner>
    )
}



const MypageCampaignInner = styled.div`
    padding : calc(100vw*(51/375)) 0 calc(100vw*(110/375)) 0;
`
const GrouProjectarea = styled.div`
    margin-top : calc(100vw*(29/375));
`